// extracted by mini-css-extract-plugin
export default {"imageContainer":"k2-z","summaryPar":"l2-z","ratingCategories":"m2-z","reviewerInfo":"n2-z","reviewTypes":"o2-z","expanded":"p2-z"};